/**
 * all actions for news state
 *
 * Created by Tom on 16/06/18
 */

import C from '../constants'


// action to hide/show the loader for the news
export const showNewsLoader = booleanVal => {
    return {
        type: C.SET_NEWS_LOADER,
        payload: booleanVal
    }
}

// action to set the news data
export const setNewsData = objectVal => {
    return {
        type: C.SET_NEWS_DATA,
        payload: objectVal
    }
}

/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */
// call the action to fetch the data
// NOTE: this will be picked up by the latest news saga
export const getNewsData = () => {
    return {
        type: C.FETCH_NEWS_DATA,
    }
}



// WEBPACK FOOTER //
// ./src/actions/newsActions.js